/**
 * Adds a message to the toasts on screen, collapsing it into the most recent one when it repeats.
 *
 * A single failing action often reports the same message several times — one per request in a
 * batch, or one per retry. Stacking those as separate toasts buries the screen in copies of one
 * sentence, so an immediate repeat becomes a count on the toast already up.
 *
 * Only the most recent toast is compared, so A, B, A stays three toasts: the middle one proves the
 * two As are separate events rather than one repeating.
 *
 * A repeat that is sticky makes the merged toast sticky. Losing a message the caller asked to keep
 * on screen is worse than leaving one up too long. A repeat without a duration of its own leaves
 * the first occurrence's in place, for the same reason.
 *
 * @returns the new list; the one passed in is left alone
 */
export const appendToastEvent = (events, incoming) => {
    var _a;
    const mostRecent = events[events.length - 1];
    if (mostRecent === undefined ||
        mostRecent.message !== incoming.message ||
        mostRecent.severity !== incoming.severity) {
        return [...events, incoming];
    }
    // The toast keeps the identity it was given, so the one on screen is updated rather than
    // replaced. Everything else is the newest occurrence's, so a repeat that names its own
    // duration or its own test id is the one that counts.
    return [
        ...events.slice(0, -1),
        {
            ...incoming,
            id: mostRecent.id,
            occurences: mostRecent.occurences + 1,
            sticky: mostRecent.sticky || incoming.sticky,
            duration: (_a = incoming.duration) !== null && _a !== void 0 ? _a : mostRecent.duration,
        },
    ];
};
